import { dataHooks } from '../../../../libs/dataHooks';

export const pageLinkDataHooks = dataHooks<{
  link: {};
}>('pageLink');
